module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/icon_day1-8f062d79578873c67b42226a9a06d2e7.png";